import { render, staticRenderFns } from "./SoftManager.vue?vue&type=template&id=f5fb1234&scoped=true&"
import script from "./SoftManager.vue?vue&type=script&lang=js&"
export * from "./SoftManager.vue?vue&type=script&lang=js&"
import style0 from "./SoftManager.vue?vue&type=style&index=0&id=f5fb1234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fb1234",
  null
  
)

export default component.exports